import { Pipe, PipeTransform } from '@angular/core';
import { Sorder } from '../models/entities/s-order';


@Pipe({
  name: 'sorder-pipe'
})

export class SorderPipe implements PipeTransform {
  
  constructor(){}



  transform(sorder: Sorder, field: string): any {
    let result = sorder[field];

    let html = "<div class='multi-labels'>";


      if (sorder.closed) {
        html += "<div class='label-orange'> Clos </div>"
      }
      if (sorder.canceled) {
        html += "<div class='label-red'> Canceled </div>"
      }
      html += "</div>";
      result = html;
    


    return result;
  }
}
